import React, { useMemo } from 'react';
import classNames from 'classnames';
import { useFormikContext } from 'formik';

import { currencyFormat } from 'legacy/common/utils/currency';

const feesLabel = (price, hostPaysFees) => {
  const examplePrice = price || 10;

  const [guestPrice, hostPrice] = [
    currencyFormat(
      parseFloat(hostPaysFees ? examplePrice : examplePrice * 1.029 + 1.3)
    ),
    currencyFormat(
      parseFloat(hostPaysFees ? examplePrice * 0.971 - 1.3 : examplePrice)
    )
  ];

  return `For a ${currencyFormat(
    examplePrice
  )} ticket, guests will pay ${guestPrice} and you will receive ${hostPrice}. Fees do not include ticket taxes (if applicable). Fees are not included in refunds.`;
};

const Button = ({ label, isActive, onClick, isDisabled }) => (
  <div
    className={classNames(
      'w-full text-center text-base font-semibold rounded-md py-2 cursor-pointer',
      {
        'bg-white': isActive
      },
      isDisabled && 'cursor-not-allowed text-neutral-500'
    )}
    onClick={onClick}
  >
    {label}
  </div>
);

const FeesPaidBy = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  const tiers = values?.pricing?.tiers || [];

  const hostPaysFees = values?.pricing?.transactionFeesPaidBy === 'host';
  const tierWithPrice = useMemo(
    () => tiers.find((tier) => tier.price > 0),
    [tiers]
  );

  const price = tierWithPrice?.price ?? 0;

  return (
    <>
      <div className="w-full p-[6px] bg-gray-200 rounded-lg flex items-center justify-between">
        <Button
          label="Guest pays fees"
          isDisabled={!values?.isDraft}
          isActive={values?.pricing?.transactionFeesPaidBy === 'guest'}
          onClick={() => {
            if (values?.isDraft) {
              setFieldValue('pricing.transactionFeesPaidBy', 'guest');
            }
          }}
        />
        <Button
          label="Host pays fees"
          isDisabled={!values?.isDraft}
          isActive={values?.pricing?.transactionFeesPaidBy === 'host'}
          onClick={() => {
            if (values?.isDraft) {
              setFieldValue('pricing.transactionFeesPaidBy', 'host');
            }
          }}
        />
      </div>
      <p className="text-xs text-gray-500 mt-3">
        {feesLabel(price, hostPaysFees)}
      </p>
    </>
  );
};

export default FeesPaidBy;
